import EventEmitter from '../support/eventemitter';

/**
 * The API object to represent UI Controls.
 * @class
 * @classdesc API Control Object
 */
export class BaseControl extends EventEmitter {
    /**
     * Wrap the specified control object as a new API Control object.
     * @param {object} rawControl - The control object this API Control object wraps.
     * @param {Object} [runtime = {}] - The optional runtime object for this control.
     */
    constructor(rawControl, runtime = {}) {
        super();

        /**
         * Internal reference to the control object.
         * @type {Object}
         */
        this.raw = rawControl;

        /**
         * Reference to this api wrapper for this control
         * @type {Object}
         */
        rawControl.apiRef = this;

        /**
         * Object that should be used for custom logic to prevent breaking the core API
         * @type {Object}
         */
        this.runtime = runtime;

        /**
         * Flag to indicate if this object has been disposed.
         * @type {boolean}
         */
        this.isDisposed = false;
    }

    /**
     * Internal Use.  Used to assist memory clean-up.
     */
    dispose() {
        if (this.isDisposed) {
            return;
        }
        this.raw.apiRef = null;
        this.raw = null;
        this.isDisposed = true;
    }
}

export class FieldControl extends BaseControl {

    /**
     * Sets the value of the field's input control to the specified value
     * @param {*} value - The value to set the field to
     */
    setValue(value) {
        if (!this.isDisposed) {
            if (this.raw.textField) {
                this.raw.textField.setValue(value);
            }
            else if (this.raw.checkboxField) {
                this.raw.checkboxField.setValue(Boolean(value));
            }
            else if (this.raw.comboBox) {
                this.raw.comboBox.setValue(value);
            }
            else {
                console.warn("setValue is currently not supported for this field type");
            }
        }
        else {
            console.error('setValue called on a disposed control API reference');
        }
    }

    /**
     * Returns the value of the field's input control
     * @returns {*} The value of the field
     */
    getValue() {
        if (!this.isDisposed) {
            let control = this.raw.textField || this.raw.checkboxField || this.raw.comboBox || this.raw.attachmentField;
            if (control) {
                return control.getValue();
            }
        }
        else {
            console.error('getValue called on a disposed control API reference');
            return null;
        }
    }
}

